export type GameIdInput = number | string | null | undefined;

export type GamesByIdsKey = readonly [
  endpoint: 'games/by-ids',
  locale: string,
  stableIdsKey: string,
];

const normalizeGameId = (value: GameIdInput): number | null => {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }

  if (typeof value !== 'string' || !/^\d+$/.test(value.trim())) return null;

  const normalizedValue = Number(value.trim());
  return Number.isSafeInteger(normalizedValue) && normalizedValue > 0
    ? normalizedValue
    : null;
};

export const normalizeGameIds = (
  ids?: readonly GameIdInput[] | null
): number[] => {
  const normalizedIds = (ids ?? [])
    .map(normalizeGameId)
    .filter((id): id is number => id !== null);

  return Array.from(new Set(normalizedIds)).sort(
    (first, second) => first - second
  );
};

export const getGamesByIdsKey = (
  locale: string,
  stableIdsKey: string
): GamesByIdsKey | null =>
  stableIdsKey ? ['games/by-ids', locale, stableIdsKey] : null;
